/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { MdOutlineMail, MdOutlineWhatsapp } from 'react-icons/md';
import { BsGraphUpArrow } from 'react-icons/bs';
import { Row, Col } from 'react-bootstrap';
import {
  emailFlightOptions,
  getSearchResultsForMulticity,
  validateMultiCityFlightPriceApi,
} from '../../api/flightApi';
import {
  getUserAgentId,
  // getObjectFromLS,
} from '../../shared/helper-utils/localStorage';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import AppButton from '../../shared/components/app-button/AppButton';
import './FlightDomesticMultiCityPage.scss';
import {
  formatCurrency,
  formatDate,
  getDateWithHypends,
  getInternationalMulitCityGroupedFlights,
  getNewDate,
  hideUpdatesOptions,
  isEmpty,
  showUpdatesOptions,
  getValueFromAppConfig,
} from '../../shared/helper-utils/appUtils';
import {
  ONLY_DATE_MONTH_FORMAT,
  // SKYTRAVELLERS_PROFILE,
  NAVIGATION_ROUTES,
  API_DATE_FORMAT,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppPreviewLoader from '../../shared/components/app-preview-loader/AppPreviewLoader';
import NoSearchResults from '../one-way/NoSearchResults';
import OneWayFilters from '../one-way/OneWayFilters';
import AppModal from '../../shared/components/app-modal/AppModal';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import CountdownTimer from '../../shared/components/countdown-timer/CountdownTimer';
import SortOptions from '../one-way/SortOptions';
import { debounce } from '../../api/apiUtils';
import IntlMultiCityResultsCard from './IntlMultiCityResultsCard';
import ModifySearch from '../flights/ModifySearch';
import IntlMultiCityWhatsappModal from './IntlMultiCityWhatsappModal';
import IntlMultiCityEmailContent from './IntlMultiCityEmailContent';
import { getUserDetails } from '../../api/profileApi';

const SEARCH_AIRLINES = ['All', 'GWS', 'GW2', '6E'];

function FlightIntlMutiCItyResultsPage() {
  const navigate = useNavigate();
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const FIFTEEN_MIN_IN_MILLI_SECS = 15 * 60 * 1000;
  const NOW_IN_MILLI_SECS = getNewDate(TODAY_DATE).getTime();
  const [fifteenMinFromNowInMilli] = useState(
    NOW_IN_MILLI_SECS + FIFTEEN_MIN_IN_MILLI_SECS,
  );
  const [searchParams] = useSearchParams();
  const [abortController, setAbortController] = useState(new AbortController());
  const [searchRequest, setSearchRequest] = useState(undefined);
  const [isModifySearch, setIsModifySearch] = useState(false);
  const [progressWidth, setProgressWidth] = useState(0);
  const showProgressRef = useRef(true);
  const [page, setPage] = useState(0);
  const [shownResults, setShownResults] = useState([]);
  const sortOrderRef = useRef('asc');
  const sortParamRef = useRef('price');
  const [searchResults, setSearchResults] = useState([]);
  const allSearchResultsRef = useRef([]);
  const [alert, setAlert] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSearchResults, setHasSearchResults] = useState(undefined);
  const progressWidthCurrentRef = useRef(1);
  const flightCarriesRef = useRef([]);
  const flightFaresRef = useRef([]);
  const [minFlightFare, setMinFlightFare] = useState(0);
  const [maxFlightFare, setMaxFlightFare] = useState(0);
  const [selectedFilters, setSelectedFilters] = useState({
    selectedMinPrice: minFlightFare,
    selectedMaxPrice: maxFlightFare,
    selectedStops: [],
    selectedDepartureTimes: [],
    selectedArraivalTimes: [],
    selectedCarriers: [],
    selectedFareTypes: [],
    selectedRefundStatus: [],
    selectedFlightNumber: '',
    selectedEquipment: '',
    isSameDayArraival: false,
  });
  const [isInternationalSearch, setInternationalSearch] = useState(false);
  const selectedFareRef = useRef(undefined);
  const selectedFlightRef = useRef(undefined);
  const [openFilters, setOpenFilters] = useState(false);
  const [showPriceChangedModal, setShowPriceChangedModal] = useState(false);
  const bookingResponseRef = useRef(null);
  const passThroughResponseRef = useRef(null);
  const [oldAmount, setOldAmount] = useState(0);
  const [newRepricedAmount, setnewRepricedAmount] = useState(0);
  const [isAmPmFormatSelected, setIsAmPmFormatSelected] = useState(false);
  const [openWhatsappModal, setOpenWhatsappModal] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [selectedForEmail, setSelectedForEmail] = useState([]);
  const agentid = getUserAgentId();
  const [showInvoiceFare, setShowInvoiceFare] = useState(false);
  useEffect(() => {
    hideUpdatesOptions();
    return () => showUpdatesOptions();
  });

  const appendResults = (pageNumber, results) => {
    const startindex = pageNumber * 10;
    const endIndex = startindex + 10;
    let newResults;
    if (startindex > results.length) {
      return;
    }
    if (endIndex > results.length) {
      newResults = results.slice(0, results.length);
    } else {
      newResults = results.slice(0, endIndex);
    }
    setShownResults(newResults);
  };

  useEffect(() => {
    appendResults(page, searchResults);
  }, [page]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollY } = window;
      const pageHeight =
        document.documentElement.scrollHeight - window.innerHeight - 100;
      if (scrollY >= pageHeight) {
        setPage((prev) => prev + 1);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSort = (param, order, isOnward, results) => {
    sortOrderRef.current = order;
    sortParamRef.current = param;
    let list;
    if (results === undefined) {
      list = [...searchResults];
    } else {
      list = results;
    }
    if (param === 'price') {
      const isTotalNet = getValueFromAppConfig('sortingtotalnet') === 'true';
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) =>
          isTotalNet
            ? flightOption2.recommendedflight[0].flightfare[0].totalnet -
              flightOption1.recommendedflight[0].flightfare[0].totalnet
            : flightOption2.recommendedflight[0].flightfare[0].totalfq -
              flightOption1.recommendedflight[0].flightfare[0].totalfq,
        );
      } else {
        list.sort((flightOption1, flightOption2) =>
          isTotalNet
            ? flightOption1.recommendedflight[0].flightfare[0].totalnet -
              flightOption2.recommendedflight[0].flightfare[0].totalnet
            : flightOption1.recommendedflight[0].flightfare[0].totalfq -
              flightOption2.recommendedflight[0].flightfare[0].totalfq,
        );
      }
    } else if (param === 'duration') {
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) => {
          let totDuration_one = 0;
          let totDuration_two = 0;
          flightOption1.recommendedflight.forEach((flt) => {
            totDuration_one += flt.totaljourneyduration;
          });
          flightOption2.recommendedflight.forEach((flt) => {
            totDuration_two += flt.totaljourneyduration;
          });
          return totDuration_two - totDuration_one;
        });
      } else {
        list.sort((flightOption1, flightOption2) => {
          let totDuration_one = 0;
          let totDuration_two = 0;
          flightOption1.recommendedflight.forEach((flt) => {
            totDuration_one += flt.totaljourneyduration;
          });
          flightOption2.recommendedflight.forEach((flt) => {
            totDuration_two += flt.totaljourneyduration;
          });
          return totDuration_one - totDuration_two;
        });
      }
    } else if (param === 'departure') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      }
    } else if (param === 'arrival') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[
                flightOption2.recommendedflight.length - 1
              ].flightlegs[
                flightOption2.recommendedflight[
                  flightOption2.recommendedflight.length - 1
                ].flightlegs.length - 1
              ].arrtime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[
                flightOption1.recommendedflight.length - 1
              ].flightlegs[
                flightOption1.recommendedflight[
                  flightOption1.recommendedflight.length - 1
                ].flightlegs.length - 1
              ].arrtime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[
                flightOption1.recommendedflight.length - 1
              ].flightlegs[
                flightOption1.recommendedflight[
                  flightOption1.recommendedflight.length - 1
                ].flightlegs.length - 1
              ].arrtime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[
                flightOption2.recommendedflight.length - 1
              ].flightlegs[
                flightOption2.recommendedflight[
                  flightOption2.recommendedflight.length - 1
                ].flightlegs.length - 1
              ].arrtime,
              10,
            ),
        );
      }
    } else if (param === 'airline') {
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) =>
          flightOption2.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption1.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      } else {
        list.sort((flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption2.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      }
    }
    setPage(0);
    appendResults(0, list);
    setSearchResults(list);
  };

  const handleSort1 = (param, order, isOnward, results) => {
    sortOrderRef.current = order;
    sortParamRef.current = param;
    let list;
    if (results === undefined) {
      list = [...searchResults];
    } else {
      list = results;
    }
    if (param === 'price') {
      const isTotalNet = getValueFromAppConfig('sortingtotalnet') === 'true';
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) =>
          isTotalNet
            ? flightOption2.recommendedflight[0].flightfare[0].totalnet -
              flightOption1.recommendedflight[0].flightfare[0].totalnet
            : flightOption2.recommendedflight[0].flightfare[0].totalfq -
              flightOption1.recommendedflight[0].flightfare[0].totalfq,
        );
      } else {
        list.sort((flightOption1, flightOption2) =>
          isTotalNet
            ? flightOption1.recommendedflight[0].flightfare[0].totalnet -
              flightOption2.recommendedflight[0].flightfare[0].totalnet
            : flightOption1.recommendedflight[0].flightfare[0].totalfq -
              flightOption2.recommendedflight[0].flightfare[0].totalfq,
        );
      }
    } else if (param === 'duration') {
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) => {
          let totDuration_one = 0;
          let totDuration_two = 0;
          flightOption1.recommendedflight.forEach((flt) => {
            totDuration_one += flt.totaljourneyduration;
          });
          flightOption2.recommendedflight.forEach((flt) => {
            totDuration_two += flt.totaljourneyduration;
          });
          return totDuration_two - totDuration_one;
        });
      } else {
        list.sort((flightOption1, flightOption2) => {
          let totDuration_one = 0;
          let totDuration_two = 0;
          flightOption1.recommendedflight.forEach((flt) => {
            totDuration_one += flt.totaljourneyduration;
          });
          flightOption2.recommendedflight.forEach((flt) => {
            totDuration_two += flt.totaljourneyduration;
          });
          return totDuration_one - totDuration_two;
        });
      }
    } else if (param === 'departure') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[0].flightlegs[0].deptime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[0].flightlegs[0].deptime,
              10,
            ),
        );
      }
    } else if (param === 'arrival') {
      if (order === 'desc') {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption2.recommendedflight[
                flightOption2.recommendedflight.length - 1
              ].flightlegs[
                flightOption2.recommendedflight[
                  flightOption2.recommendedflight.length - 1
                ].flightlegs.length - 1
              ].arrtime,
              10,
            ) -
            parseInt(
              flightOption1.recommendedflight[
                flightOption1.recommendedflight.length - 1
              ].flightlegs[
                flightOption1.recommendedflight[
                  flightOption1.recommendedflight.length - 1
                ].flightlegs.length - 1
              ].arrtime,
              10,
            ),
        );
      } else {
        list.sort(
          (flightOption1, flightOption2) =>
            parseInt(
              flightOption1.recommendedflight[
                flightOption1.recommendedflight.length - 1
              ].flightlegs[
                flightOption1.recommendedflight[
                  flightOption1.recommendedflight.length - 1
                ].flightlegs.length - 1
              ].arrtime,
              10,
            ) -
            parseInt(
              flightOption2.recommendedflight[
                flightOption2.recommendedflight.length - 1
              ].flightlegs[
                flightOption2.recommendedflight[
                  flightOption2.recommendedflight.length - 1
                ].flightlegs.length - 1
              ].arrtime,
              10,
            ),
        );
      }
    } else if (param === 'airline') {
      if (order === 'desc') {
        list.sort((flightOption1, flightOption2) =>
          flightOption2.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption1.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      } else {
        list.sort((flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightlegs[0].validatingcarriername.localeCompare(
            flightOption2.recommendedflight[0].flightlegs[0]
              .validatingcarriername,
          ),
        );
      }
    }
    setPage(0);
    appendResults(0, list);
    return list;
  };

  const handleApplyFilter = debounce((filters) => {
    setOpenFilters(false);
    setSelectedFilters(filters);
    let filteredSearchResults =
      filters.selectedCarriers.length > 0
        ? allSearchResultsRef.current.filter((resultRow) => {
            let legs = resultRow.recommendedflight[0].flightlegs;
            legs = Array.isArray(legs) ? legs : [legs];
            return legs.some(
              (x) =>
                filters.selectedCarriers.indexOf(x.validatingcarriername) > -1,
            );
          })
        : allSearchResultsRef.current;
    filteredSearchResults =
      filters.selectedRefundStatus.length > 0
        ? filteredSearchResults.filter((resultRow) => {
            let fares = resultRow.recommendedflight[0].flightfare;
            fares = Array.isArray(fares) ? fares : [fares];
            return fares.some(
              (x) =>
                filters.selectedRefundStatus.indexOf(x.refundableinfo) > -1,
            );
          })
        : filteredSearchResults;
    filteredSearchResults =
      filters.selectedStops.length > 0
        ? filteredSearchResults.filter(
            (resultRow) =>
              filters.selectedStops.indexOf(
                (
                  resultRow.recommendedflight[0].flightlegs.length - 1
                ).toString(),
              ) > -1,
          )
        : filteredSearchResults;
    filteredSearchResults =
      filters.selectedDepartureTimes.length > 0
        ? filteredSearchResults.filter((resultRow) => {
            const depTime = Number(
              resultRow.recommendedflight[0].flightlegs[0].deptime,
            );
            return filters.selectedDepartureTimes.some((timeRange) => {
              const timeRangeArr = timeRange.split('-');
              return (
                depTime >= Number(timeRangeArr[0]) &&
                depTime <= Number(timeRangeArr[1])
              );
            });
          })
        : filteredSearchResults;
    filteredSearchResults =
      filters.selectedArraivalTimes.length > 0
        ? filteredSearchResults.filter((resultRow) => {
            const depTime = Number(
              resultRow.recommendedflight[Number(searchRequest.numsectors) - 1]
                .flightlegs[
                resultRow.recommendedflight[
                  Number(searchRequest.numsectors) - 1
                ].flightlegs.length - 1
              ].arrtime,
            );
            return filters.selectedArraivalTimes.some((timeRange) => {
              const timeRangeArr = timeRange.split('-');
              return (
                depTime >= Number(timeRangeArr[0]) &&
                depTime <= Number(timeRangeArr[1])
              );
            });
          })
        : filteredSearchResults;
    filteredSearchResults = filters.selectedMinPrice
      ? filteredSearchResults.filter(
          (resultRow) =>
            resultRow.recommendedflight[0].flightfare[0].totalfq >=
            filters.selectedMinPrice,
        )
      : filteredSearchResults;
    filteredSearchResults = filters.selectedMaxPrice
      ? filteredSearchResults.filter(
          (resultRow) =>
            resultRow.recommendedflight[0].flightfare[0].totalfq <=
            filters.selectedMaxPrice,
        )
      : filteredSearchResults;
    filteredSearchResults = handleSort1(
      sortParamRef.current,
      sortOrderRef.current,
      true,
      filteredSearchResults,
    );
    setSearchResults(filteredSearchResults);
  }, 300);

  const updateFlightsState = (response) => {
    if (
      response &&
      response.flightjourneys[0] !== '' &&
      response.flightjourneys[0] !== undefined &&
      response.flightjourneys[0].flightoptions.length !== 0
    ) {
      const flightOptions = Array.isArray(
        response.flightjourneys[0].flightoptions,
      )
        ? response.flightjourneys[0].flightoptions
        : [response.flightjourneys[0].flightoptions];
      flightOptions?.forEach((ele) => {
        let legs = ele.recommendedflight[0].flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        const { validatingcarriername, validatingcarrier } = legs[0];
        if (
          !flightCarriesRef.current.some(
            (x) => x.validatingcarriername === validatingcarriername,
          )
        ) {
          flightCarriesRef.current.push({
            validatingcarriername,
            validatingcarrier,
          });
        }
        flightCarriesRef.current.sort((option1, option2) =>
          option1.validatingcarriername.localeCompare(
            option2.validatingcarriername,
          ),
        );
      });
      flightOptions?.forEach((ele) => {
        let fares = ele?.recommendedflight[0]?.flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const { faretype } = fares[0];
        if (!isEmpty(faretype)) {
          if (
            !flightFaresRef.current.some(
              (x) => x.toLowerCase() === faretype.toLowerCase(),
            )
          ) {
            flightFaresRef.current.push(faretype);
          }
          flightFaresRef.current.sort((option1, option2) =>
            option1.localeCompare(option2),
          );
        }
      });
      flightOptions.forEach((fo) => {
        let fares = fo.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        fares.forEach((fare) => {
          const carrierList = [];
          const seatsList = [];
          const bagList = [];
          const weighlist = [];
          const bookingClassList = [];
          const airFreeTextList = [];
          const equipmentList = [];
          const operatedByList = [];
          fo.recommendedflight.forEach((flt) => {
            const legCarriers = [];
            const legSeats = [];
            const legBags = [];
            const legWeights = [];
            const legBookingClass = [];
            const legAirFreeText = [];
            const legEquipment = [];
            const legOpetatedBy = [];
            flt.flightlegs.forEach((leg) => {
              legCarriers.push(leg.carrier);
              legSeats.push(leg.numseatsavailable);
              legBags.push(leg.bagweight);
              legWeights.push(leg.bagunit);
              legBookingClass.push(leg.bookingclass);
              legEquipment.push(isEmpty(leg.equipment) ? '' : leg.equipment);
              legOpetatedBy.push(isEmpty(leg.operatedby) ? '' : leg.operatedby);
              if (leg.weather_origin !== '') {
                legAirFreeText.push(leg.weather_origin);
              } else {
                legAirFreeText.push('-');
              }
            });
            carrierList.push(legCarriers);
            seatsList.push(legSeats);
            bagList.push(legBags);
            weighlist.push(legWeights);
            bookingClassList.push(legBookingClass);
            airFreeTextList.push(legAirFreeText);
            equipmentList.push(legEquipment);
            operatedByList.push(legOpetatedBy);
          });
          fare.supplierName = fo.recommendedflight[0].supplier;
          fare.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
          fare.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
          fare.flightCarrier = carrierList;
          fare.numseatsavailable = seatsList;
          fare.flightBagWeight = bagList;
          fare.flightBagUnit = weighlist;
          fare.bookingClass = bookingClassList;
          fare.airFreeText = airFreeTextList;
          fare.flightEquipment = equipmentList;
          fare.flightOperatedBy = operatedByList;
        });
      });
      const allFlights = [...flightOptions, ...allSearchResultsRef.current];

      let groupedFlightOptions =
        getInternationalMulitCityGroupedFlights(allFlights);
      groupedFlightOptions = Object.values(groupedFlightOptions);
      const updatedGroupedOptions = [...groupedFlightOptions];
      const isTotalNet = getValueFromAppConfig('sortingtotalnet') === 'true';
      updatedGroupedOptions.sort((flightOption1, flightOption2) =>
        isTotalNet
          ? flightOption1.recommendedflight[0].flightfare[0].totalnet -
            flightOption2.recommendedflight[0].flightfare[0].totalnet
          : flightOption1.recommendedflight[0].flightfare[0].totalfq -
            flightOption2.recommendedflight[0].flightfare[0].totalfq,
      );
      let minFare = minFlightFare;
      let maxFare = maxFlightFare;

      if (updatedGroupedOptions.length > 1) {
        minFare =
          updatedGroupedOptions[0].recommendedflight[0].flightfare[0].totalfq;
        maxFare =
          updatedGroupedOptions[updatedGroupedOptions.length - 1]
            .recommendedflight[0].flightfare[0].totalfq;
      }
      allSearchResultsRef.current = updatedGroupedOptions;
      allSearchResultsRef.current.forEach((ele) => {
        let fares = ele.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        fares.forEach((fare) => {
          if (!flightFaresRef.current.some((x) => x === fare.faretype)) {
            flightFaresRef.current.push(fare.faretype);
          }
        });
      });
      setMinFlightFare(minFare);
      setMaxFlightFare(maxFare);
      setSearchResults(updatedGroupedOptions);
      setHasSearchResults(true);
    }
  };

  const getFlightSearchResults = async (mergedSearchObj, controller) => {
    try {
      SEARCH_AIRLINES.forEach(async (airline) => {
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'normal';
        try {
          const response = await getSearchResultsForMulticity(
            mergedSearchObj,
            controller,
          );
          if (response.domint === 'international') {
            setInternationalSearch(true);
          }
          if (progressWidthCurrentRef.current === SEARCH_AIRLINES.length) {
            showProgressRef.current = false;
          }
          setProgressWidth(
            (progressWidthCurrentRef.current * 100) / SEARCH_AIRLINES.length,
          );
          progressWidthCurrentRef.current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.log(error);
        }
      });
    } catch (error) {
      return undefined;
    }
  };

  const resetSearchResults = () => {
    selectedFareRef.current = undefined;
    selectedFlightRef.current = undefined;
    setMinFlightFare(0);
    setMaxFlightFare(0);
    setSearchResults([]);
    setProgressWidth(0);
    setHasSearchResults(undefined);
    setIsModifySearch(false);
    allSearchResultsRef.current = [];
    flightCarriesRef.current = [];
    flightFaresRef.current = [];
    showProgressRef.current = true;
    sortOrderRef.current = 'asc';
    sortParamRef.current = 'price';
    setPage(1);
    progressWidthCurrentRef.current = 1;
    setSelectedFilters({
      selectedMinPrice: minFlightFare,
      selectedMaxPrice: maxFlightFare,
      selectedStops: [],
      selectedDepartureTimes: [],
      selectedArraivalTimes: [],
      selectedCarriers: [],
      selectedFareTypes: [],
      selectedRefundStatus: [],
      selectedFlightNumber: '',
      selectedEquipment: '',
      isSameDayArraival: false,
    });
    setOldAmount(0);
    setnewRepricedAmount(0);
    bookingResponseRef.current = null;
  };

  useEffect(() => {
    setAbortController(new AbortController());
    if (searchParams) {
      const currentParams = Object.fromEntries([...searchParams]);
      setSearchRequest(currentParams);
      const searchObj = {
        origin: '',
        destination: '',
        onwarddate: getNewDate(TODAY_DATE),
        returndate: '',
        numadults: '1',
        numchildren: '0',
        numinfants: '0',
        journeytype: 'MultiCity',
        prefclass: 'Y',
        requestformat: 'JSON',
        resultformat: 'JSON',
        searchtype: 'normal',
        sortkey: '',
        issbt: 'false',
        profileid: '',
        numresults: 100,
        actionname: 'FLIGHTSEARCH',
        preddeptimewindow: null,
        prefarrtimewindow: null,
        prefcarrier: '',
        excludecarriers: '',
        refundtype: 'All',
        layovertime: '',
        promocode: '',
        nonstopsearch: 'false',
        agentid: getUserAgentId(),
      };
      const mergedSearchObj = { ...searchObj, ...currentParams };
      resetSearchResults();
      const controller = abortController;
      const { signal } = controller;
      getFlightSearchResults(mergedSearchObj, signal);
    }
    return () => {
      if (abortController) {
        abortController.abort(); // Clean up controller on component unmount or query change
      }
    };
  }, [searchParams]);

  useEffect(() => {
    if (allSearchResultsRef.current.length > 0) {
      handleApplyFilter(selectedFilters);
    }
  }, [allSearchResultsRef.current]);

  const getJourneys = (origin, destination, dates) => {
    const originArr = origin.split(':');
    const destinationArr = destination.split(':');
    const newDatesArray = [];
    const datesArray = dates.split(':');
    datesArray.forEach((date) => {
      let newdate = `${date.substring(0, 4)}-${date.substring(
        4,
        6,
      )}-${date.substring(6, 8)}`;
      newdate = formatDate(getNewDate(newdate), ONLY_DATE_MONTH_FORMAT);
      newDatesArray.push(newdate);
    });
    const journeyStringArr = new Array(Number(originArr.length))
      .fill(0)
      .map(
        (d, index) =>
          `${originArr[index].split(',')[0]}-${
            destinationArr[index].split(',')[0]
          }(${newDatesArray[index]})`,
      );
    return journeyStringArr.join(', ');
  };

  const handleTimeFormatChange = (isAmPmFormat) => {
    setIsAmPmFormatSelected(isAmPmFormat);
  };

  const navigateToBookingPage = (rePriceResponse, selectedFareParam) => {
    const flight = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight,
    };
    const fare = {
      onward:
        rePriceResponse.flightjourneys[0].flightoptions[0].recommendedflight[0]
          .flightfare,
    };
    const fareKeys = {
      onward:
        selectedFareParam?.nextraflightkey ||
        selectedFareRef.current?.nextraflightkey,
    };
    navigate(NAVIGATION_ROUTES.FLIGHT.FLIGHT_BOOK_ROUTE, {
      state: {
        searchRequest,
        rePriceResponse,
        selectedFlight: flight,
        selectedFare: fare,
        passThroughInfo: passThroughResponseRef.current,
        selectedFareKeys: fareKeys,
        journeyType: 'multicity',
        domInt: 'international',
      },
    });
  };

  const handleBook = async () => {
    try {
      setIsLoading(true);
      const response = await validateMultiCityFlightPriceApi(
        'international',
        selectedFareRef.current.nextraflightkey,
      );
      setIsLoading(false);
      if (
        response &&
        response.NextraPricingResponseV4 &&
        response.NextraPricingResponseV4.statuscode === '200'
      ) {
        if (response.NextraPricingResponseV4.pricechanged) {
          bookingResponseRef.current = response.NextraPricingResponseV4;
          setnewRepricedAmount(response.NextraPricingResponseV4.newamount);
          setOldAmount(response.NextraPricingResponseV4.oldamount);
          setShowPriceChangedModal(true);
        } else {
          navigateToBookingPage(response.NextraPricingResponseV4);
        }
      } else {
        setAlert({
          title: 'Booking Error',
          description: response.ApiStatus?.Message || 'Error',
          variant: 'error',
        });
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleFareSelection = (flight, fare) => {
    selectedFareRef.current = fare;
    selectedFlightRef.current = flight;
    handleBook();
  };
  const handlePriceChangedModalClose = (isContinue) => {
    if (isContinue) {
      navigateToBookingPage(bookingResponseRef.current);
    }
    setShowPriceChangedModal(false);
  };

  const handleFlightSelectionForEmail = (flights, fare) => {
    setSelectedForEmail((prev) => {
      if (
        prev.some(
          (selectedItem) =>
            selectedItem.fare.nextraflightkey === fare.nextraflightkey,
        )
      ) {
        return prev.filter(
          (selectedItem) =>
            selectedItem.fare.nextraflightkey !== fare.nextraflightkey,
        );
      }
      return [...prev, { flights, fare }];
    });
  };
  const handleopenWhatsappModal = () => {
    if (selectedForEmail.length > 0) {
      setOpenWhatsappModal(true);
    } else {
      setAlert({
        title: 'WhatsApp flight options',
        description: 'Select atleast one fare',
        variant: 'error',
      });
    }
  };

  const handleOpenEmailModal = () => {
    if (selectedForEmail.length > 0) {
      setOpenEmailModal(true);
    } else {
      setAlert({
        title: 'Email flight options',
        description: 'Select atleast one fare',
        variant: 'error',
      });
    }
  };
  const handleSendWhatsappMessage = (whatsappNumber, msg) => {
    setIsLoading(true);
    const encodedMessage = encodeURIComponent(msg);
    const whatsAppUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsAppUrl, '_blank');
    setOpenWhatsappModal(false);
    setSelectedForEmail([]);
    setIsLoading(false);
  };

  const handleSendEmailMessage = async (senderEmail, emailContent) => {
    setIsLoading(true);
    let fromEmail = '';
    let fromName = '';
    const res = await getUserDetails(agentid);
    if (res.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      fromEmail = User.ContactEmail;
      fromName = `${User.FirstName} ${User.LastName}`;
    }
    if (fromEmail !== '') {
      let emailSubject = 'Your flight booking details for ';
      searchRequest.origin.split(':').forEach((d, index) => {
        emailSubject += `${
          searchRequest.originlocations.split(':')[index].split(',')[0]
        } - ${
          searchRequest.destinationlocations.split(':')[index].split(',')[0]
        } | ${getDateWithHypends(searchRequest.onwarddate.split(':')[index])} ${
          index !== searchRequest.origin.split(':').length - 1 ? ',' : ''
        }`;
      });
      const response = await emailFlightOptions(
        fromEmail,
        fromName,
        senderEmail,
        emailContent,
        emailSubject,
      );
      if (response && response?.Root?.Status === 'OK') {
        setAlert({
          title: formattedMessage('email_btn'),
          description: formattedMessage('email_sent_successfully'),
          variant: 'success',
        });
        setOpenEmailModal(false);
        setIsLoading(false);
      } else {
        setAlert({
          title: formattedMessage('email_btn'),
          description: response?.Root?.Message
            ? response?.Root?.Message
            : formattedMessage('failed_send_email'),
          variant: 'error ',
        });
        setOpenEmailModal(false);
        setIsLoading(false);
      }
    } else {
      setAlert({
        title: formattedMessage('user_Details'),
        description: res.ApiStatus?.Message
          ? res.ApiStatus?.Message
          : formattedMessage('failed_toload_agent_Details'),
        variant: 'error ',
      });
      setOpenEmailModal(false);
      setIsLoading(false);
    }
    setSelectedForEmail([]);
  };
  return (
    searchRequest && (
      <div className="multicity-search-results">
        <AppLoading isLoading={isLoading} />
        {alert && (
          <AppAlert
            showIcon
            variant={alert.variant}
            title={alert.title}
            onHide={() => setAlert(undefined)}
            description={alert.description}
          />
        )}
        {showProgressRef.current && (
          <div className="flight-progress-container">
            <ProgressBar striped variant="info" now={progressWidth} />
          </div>
        )}
        <div className="countdown-timer-container visually-hidden">
          <CountdownTimer
            targetDate={fifteenMinFromNowInMilli}
            continueBtnText="Continue"
            continueRoutePath="refresh"
          />
        </div>
        {searchRequest && (
          <div className="multicity-search-results_header">
            <div className="multicity-search-results_header_container">
              <Row>
                <Col lg={10} md={12} sm={12} xs={12}>
                  <Row>
                    <Col
                      lg={9}
                      md={9}
                      sm={9}
                      xs={9}
                      className="d-flex flex-column"
                    >
                      <span className="fs-10">Journeys </span>
                      <span className="fs-16 fw-600">
                        {getJourneys(
                          searchRequest.originlocations,
                          searchRequest.destinationlocations,
                          searchRequest.onwarddate,
                        )}
                      </span>
                    </Col>
                    <Col
                      lg={3}
                      md={3}
                      sm={3}
                      xs={3}
                      className="d-flex flex-column"
                    >
                      <span className="fs-10">Passengers</span>
                      <span className="fs-16 fw-600">
                        {parseInt(searchRequest.numadults, 10) +
                          parseInt(searchRequest.numchildren, 10) +
                          parseInt(searchRequest.numinfants, 10)}{' '}
                        Passengers
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col lg={2} md={2} sm={3} xs={12}>
                  <div className="d-flex justify-content-end">
                    {isModifySearch ? (
                      <AppButton
                        btnText="Close"
                        className="px-4"
                        variant="outlined-secondary"
                        onClick={() => setIsModifySearch(false)}
                      />
                    ) : (
                      <AppButton
                        btnText="Modify"
                        className="px-4"
                        variant="outlined-secondary"
                        onClick={() => setIsModifySearch(true)}
                      />
                    )}
                  </div>
                </Col>
              </Row>
              {isModifySearch && (
                <div className="slide-container">
                  <ModifySearch
                    isModifySearch={isModifySearch}
                    previousSearchRequest={searchRequest}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        {progressWidth < 100 && allSearchResultsRef.current.length === 0 && (
          <AppPreviewLoader />
        )}
        {hasSearchResults ? (
          <section className="flight-app-container px-sm-3 p-1 pb-3">
            <Row className="spacing-16">
              <Col lg={3} className=" display-md-none p-0 mt-4">
                <OneWayFilters
                  minPrice={minFlightFare}
                  maxPrice={maxFlightFare}
                  carriers={flightCarriesRef.current}
                  fareTypes={flightFaresRef.current}
                  selectedFilters={selectedFilters}
                  onApplyFilter={handleApplyFilter}
                  onTimeFormatChange={handleTimeFormatChange}
                  isAmPmFormat={isAmPmFormatSelected}
                />
              </Col>
              <Col lg={9}>
                <div className="fs-5 fw-500 black-color d-flex justify-content-end">
                  <AppIconButton
                    variant="white"
                    className="fs-14 black-color"
                    onClick={handleopenWhatsappModal}
                  >
                    <MdOutlineWhatsapp title="WhatsApp" />
                  </AppIconButton>
                  <AppIconButton
                    variant="white"
                    className="fs-14 black-color"
                    onClick={handleOpenEmailModal}
                  >
                    <MdOutlineMail title="Email" />
                  </AppIconButton>
                  <AppIconButton
                    variant="white"
                    className="fs-14 black-color"
                    onClick={() => setShowInvoiceFare((prev) => !prev)}
                  >
                    {showInvoiceFare ? (
                      <IoMdEyeOff title="Net Fare" />
                    ) : (
                      <IoMdEye title="Net Fare" />
                    )}
                  </AppIconButton>
                </div>
                <div className="my-1">
                  <div className="flight-sort-options d-flex">
                    <div
                      className={`sort-btn ${
                        sortParamRef.current === 'price'
                          ? 'selected-sort-btn'
                          : ''
                      }`}
                      onClick={() => handleSort('price', 'asc')}
                    >
                      Cheapest Flights
                    </div>
                    <div
                      className={`sort-btn border-inline ${
                        sortParamRef.current === 'duration'
                          ? 'selected-sort-btn'
                          : ''
                      }`}
                      onClick={() => handleSort('duration', 'asc')}
                    >
                      Shortest Duration
                    </div>
                    <div
                      className={`sort-btn ${
                        sortParamRef.current === 'departure'
                          ? 'selected-sort-btn'
                          : ''
                      }`}
                      onClick={() => handleSort('departure', 'asc')}
                    >
                      Early Depart
                    </div>
                  </div>
                </div>
                {shownResults.map((row, index) => (
                  <IntlMultiCityResultsCard
                    name="one_way_card"
                    domint="international"
                    key={row.recommendedflight[0].nextraflightkey}
                    flights={row.recommendedflight}
                    onwardFares={row.recommendedflight[0].flightfare}
                    selectedFare={selectedFareRef.current}
                    onFareSelection={handleFareSelection}
                    journeyType={searchRequest.journeytype}
                    searchRequest={searchRequest}
                    index={index}
                    onSelectForEmail={handleFlightSelectionForEmail}
                    flightsForEmail={selectedForEmail}
                    showInvoiceFare={showInvoiceFare}
                    isAmPmFormat={isAmPmFormatSelected}
                    onNavigateToBookingPage={navigateToBookingPage}
                  />
                ))}
                {searchResults.length === 0 && progressWidth === 100 && (
                  <NoSearchResults message="Please change your filter criteria and try again" />
                )}
              </Col>
            </Row>
          </section>
        ) : (
          allSearchResultsRef.current.length === 0 &&
          progressWidth === 100 && (
            <NoSearchResults message="Please change your criteria and try again" />
          )
        )}
        {openFilters && (
          <AppSidebar
            sidebarTitle="Filter"
            showActions
            onHideSidebar={() => setOpenFilters(false)}
          >
            <OneWayFilters
              minPrice={minFlightFare}
              maxPrice={maxFlightFare}
              carriers={flightCarriesRef.current}
              fareTypes={flightFaresRef.current}
              selectedFilters={selectedFilters}
              onApplyFilter={handleApplyFilter}
              //   onTimeFormatChange={handleTimeFormatChange}
            />
          </AppSidebar>
        )}
        {showPriceChangedModal && (
          <AppModal
            modalTitle="Fare Change Alert"
            showCloseButton={false}
            okText="Continue"
            cancelText="Select Another Flight"
            showFooter
            onModalClose={handlePriceChangedModalClose}
          >
            <div className="d-flex flex-column align-items-center red-color fs-3">
              <BsGraphUpArrow />
              <span>Ooops!</span>
            </div>
            <p className="fs-14 mb-0 text-center mt-2">
              The Airline has increased the fare on this route by{' '}
              {formatCurrency(newRepricedAmount - oldAmount)}
            </p>
            <p className="fs-14 mb-0 text-center">
              Please note that airfares e dynamicnd subject to change.
            </p>
            <p className="fs-14 mb-0 text-center">
              Select from the options below
            </p>
            <div className="d-flex flex-column align-items-center fw-600 fs-14 mt-3">
              <span>
                UPDATED FARE{'      '} {formatCurrency(newRepricedAmount)}
              </span>
              <span>
                ORIGINAL FARE{'      '} {formatCurrency(oldAmount)}
              </span>
              <span>
                DIFFERENCE FARE{'      '}{' '}
                {formatCurrency(newRepricedAmount - oldAmount)}
              </span>
            </div>
          </AppModal>
        )}
        {openWhatsappModal && (
          <AppModal
            modalTitle="Send WhatsApp"
            showCloseButton
            size="lg"
            onModalClose={() => setOpenWhatsappModal(false)}
          >
            <IntlMultiCityWhatsappModal
              onSend={handleSendWhatsappMessage}
              selectedFlights={selectedForEmail}
              searchRequest={searchRequest}
            />
          </AppModal>
        )}
        {openEmailModal && (
          <AppModal
            showCloseButton
            onModalClose={() => setOpenEmailModal(false)}
            size="lg"
            modalTitle="Send Email"
          >
            <IntlMultiCityEmailContent
              selectedFlights={selectedForEmail}
              onSend={handleSendEmailMessage}
              searchRequest={searchRequest}
            />
          </AppModal>
        )}
      </div>
    )
  );
}

export default FlightIntlMutiCItyResultsPage;
